// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".c-info-data-button-mobile-sticky[data-v-311fcd3a],.i-is-stuck-on-mobile .c-info-data-button[data-v-311fcd3a]{display:none}.i-is-stuck-on-mobile .c-info-data-button-mobile-sticky[data-v-311fcd3a]{align-self:flex-end;display:flex}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
